import { render } from "./Katisashi.vue?vue&type=template&id=6ce7fb6e"
import script from "./Katisashi.vue?vue&type=script&lang=js"
export * from "./Katisashi.vue?vue&type=script&lang=js"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__